import React from 'react';
import './ParticipantList.css';

const ParticipantList = ({ participants, user, currentSpeaker }) => {
  const allParticipants = [...participants, user];

  return (
    <div className="participant-list">
      <h3>Participants</h3>
      
      {allParticipants.map((participant) => {
        const isTyping = currentSpeaker === participant.id;
        
        return (
          <div 
            key={participant.id}
            className={`participant ${isTyping ? 'active' : ''}`}
          >
            <div 
              className="participant-avatar"
              style={{ 
                backgroundColor: `${participant.color}20`,
                borderColor: participant.color 
              }}
            >
              {participant.avatar}
            </div>
            
            <div className="participant-info">
              <div className="participant-name">{participant.name}</div>
              <div className="participant-title">{participant.title}</div>
            </div>
            
            <div 
              className={`status-dot ${isTyping ? 'typing' : ''}`}
              style={{ backgroundColor: isTyping ? '#FF9800' : '#4CAF50' }}
            />
          </div>
        );
      })}
      
      <div className="participant-legend">
        <div className="legend-item">
          <div className="status-dot" style={{ backgroundColor: '#4CAF50' }} />
          <span>Online</span>
        </div>
        <div className="legend-item">
          <div className="status-dot typing" style={{ backgroundColor: '#FF9800' }} />
          <span>Typing</span>
        </div>
      </div>
    </div>
  );
};

export default ParticipantList;
